import { render, staticRenderFns } from "./TelnyxChannels.vue?vue&type=template&id=2e0f2c66&scoped=true"
import script from "./TelnyxChannels.vue?vue&type=script&lang=js"
export * from "./TelnyxChannels.vue?vue&type=script&lang=js"
import style0 from "./TelnyxChannels.vue?vue&type=style&index=0&id=2e0f2c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0f2c66",
  null
  
)

export default component.exports